import {
  CURRENT_PERFORMANCE_FETCH_COMPLETED,
  TASKS_FETCH_COMPLETED,
  IND_RESULT_FILES_FETCH_COMPLETED,
  GROUP_RESULT_FILES_FETCH_COMPLETED,
  STUDENT_PROJECTS_FETCH_COMPLETED,
  STUDENT_PROJECT_FETCH_COMPLETED,
  STUDENTS_FETCH_COMPLETED,
  CURRENT_PERFORMANCE_FETCH_STARTED,
  CURRENT_PERFORMANCE_LOADING_OFF,
  SET_STUDENTS_PAGES_COUNT,
} from "../actions/types";

const initialState = {
  isLoading: false,
  currentPerformances: [],
  studentProjects: [],
  selectedProject: null,
  students: [],
  resultIndStudent: [],
  modalWindow: {
    data: [],
  },
  studentPagesCount: 0,
  // общее количество найденных записей — приходит вместе со страницей
  // (заголовок X-Total-Count), а не только количество строк на текущей
  studentsTotalCount: 0,
};

export default function performance(state = initialState, action) {
  switch (action.type) {
    case CURRENT_PERFORMANCE_FETCH_STARTED:
      return {
        ...state,
        isLoading: true,
      };
    case CURRENT_PERFORMANCE_FETCH_COMPLETED:
      return {
        ...state,
        isLoading: false,
        currentPerformances: action.data,
      };
    case STUDENT_PROJECTS_FETCH_COMPLETED:
      return {
        ...state,
        studentProjects: action.data,
      };
    case STUDENT_PROJECT_FETCH_COMPLETED:
      return {
        ...state,
        selectedProject: action.data,
      };
    case STUDENTS_FETCH_COMPLETED:
      return {
        ...state,
        students: action.data,
        isLoading: false
      };
    case IND_RESULT_FILES_FETCH_COMPLETED:
      return {
        ...state,
        resultIndStudent: action.data,
      };
    case GROUP_RESULT_FILES_FETCH_COMPLETED:
      return {
        ...state,
        resultGroupStudents: action.data,
      };
    case TASKS_FETCH_COMPLETED:
      return {
        ...state,
        modalWindow: {
          data: action.data,
        },
      };
    case CURRENT_PERFORMANCE_LOADING_OFF:
      return {
        ...state,
        isLoading: false,
      };
    case SET_STUDENTS_PAGES_COUNT:
      return {
        ...state,
        studentPagesCount: action.payload?.pagesCount || 0,
        studentsTotalCount: action.payload?.totalCount || 0,
      };
    default:
      return state;
  }
}
